import { join } from "@p0security/frontend-core/react";
import { Flex } from "@p0security/ui";

import { GraphTooltip } from "../../../GraphTooltip";
import { HasAddTerm, ShowHideTerm } from "./ShowHide";

type Props = {
  getInverseTerm?: (val: string) => string;
  getSearchTerm: (val: string) => string;
  inputMap: Record<string, any[] | number>;
  termName: string;
  typeOptions: readonly string[];
};

// 0000 takes 2.5em in most aggressive rendered font
const COUNT_CLASSES = "inline-block w-[3.2em]";

const renderCount = (count: number) => (count === 0 ? "" : String(count));
export const CountAggregate: React.FC<Props & HasAddTerm> = ({
  getInverseTerm,
  getSearchTerm,
  inputMap,
  onAddTerm,
  termName,
  terms,
  typeOptions,
}) => {
  if (!inputMap) inputMap = {};
  for (const option of typeOptions) {
    if (!inputMap[option]) {
      inputMap[option] = [];
    }
  }

  const extracted = typeOptions.map((t) => {
    const value = inputMap[t];
    const count = typeof value === "number" ? value : value.length;
    return [t, count] as const;
  });

  return (
    <Flex wrap="nowrap">
      {join(
        extracted.map(([pt, p], ix) =>
          p ? (
            <GraphTooltip
              key={ix}
              title={
                <ShowHideTerm
                  inverse={getInverseTerm?.(pt)}
                  term={getSearchTerm(pt)}
                  name={termName}
                  onAddTerm={onAddTerm}
                  terms={terms}
                />
              }
            >
              <div key={ix} className={COUNT_CLASSES}>
                {renderCount(p)}
              </div>
            </GraphTooltip>
          ) : (
            <div key={ix} className={COUNT_CLASSES} />
          )
        ),
        (ix) => (
          <div key={`slash-${ix}`} className="px-[0.5em] text-[darkgray]">
            /
          </div>
        )
      )}
    </Flex>
  );
};
